// AddStaffModal.jsx
import React, { useState } from 'react';
import styles from './AddStaffModal.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';
import ToClose from '../../components/ToClose/ToClose';
import RadioComponent from '../../components/RadioComponent/RadioComponent';
import HeadingAndData from '../../components/HeadingAndData/HeadingAndData';
import HeadingAndDropDown from '../../components/HeadingAndDropDown/HeadingAndDropDown';
import { FaUserPlus, FaUser } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';

const AddStaffModal = () => {
  const dispatch = useDispatch();

  const [gender, setGender] = useState('Male');
  const [staffFirstName, setStaffFirstName] = useState('');
  const [staffLastName, setStaffLastName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [address, setAddress] = useState('');
  const [role, setRole] = useState('');
  const [room, setRoom] = useState('');
  const [program, setProgram] = useState('');
  const [group, setGroup] = useState('');
  const [joinDate, setJoinDate] = useState('');

  return (
    <div className={styles.AddStaffModal}>
      <div className={styles.container}>
        <div className={styles.header}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Add Staff" />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>

        {/* Personal Details */}
        <div className={styles.sectionBox}>
          <div className={styles.sectionContainer}>
            <div className={styles.sectionHeaderBox}>
              <HeadingAndIcon icon={<FaUser />} heading="Personal Details" />
            </div>

            <div className={styles.inputCard}>
              <div className={styles.inputsRow}>
                <HeadingAndData
                  label="Staff First Name"
                  name="staffFirstName"
                  placeholder="Enter Staff Firstname"
                  value={staffFirstName}
                  onChange={(e) =>
                    /^[a-zA-Z\s]*$/.test(e.target.value) &&
                    setStaffFirstName(e.target.value)
                  }
                  required
                />
                <HeadingAndData
                  label="Staff Last Name"
                  name="staffLastName"
                  placeholder="Enter Staff Lastname"
                  value={staffLastName}
                  onChange={(e) =>
                    /^[a-zA-Z\s]*$/.test(e.target.value) &&
                    setStaffLastName(e.target.value)
                  }
                  required
                />
                <div className={styles.radioGroup}>
                  <span className={styles.radioLabelTitle}>Gender *</span>
                  <div className={styles.radioOptions}>
                    <RadioComponent
                      name="gender"
                      value="Male"
                      label="Male"
                      checked={gender === 'Male'}
                      onChange={(e) => setGender(e.target.value)}
                    />
                    <RadioComponent
                      name="gender"
                      value="Female"
                      label="Female"
                      checked={gender === 'Female'}
                      onChange={(e) => setGender(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.inputsRow}>
                <HeadingAndData
                  label="Mobile Number"
                  name="mobile"
                  placeholder="Enter mobile Number"
                  value={mobile}
                  onChange={(e) =>
                    /^\d{0,10}$/.test(e.target.value) &&
                    setMobile(e.target.value)
                  }
                  required
                />
                <HeadingAndData
                  label="Email ID"
                  name="email"
                  placeholder="Enter Email ID"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onBlur={(e) => {
                    const value = e.target.value.trim();
                    if (value !== '' && !value.includes('@')) {
                      alert('Invalid Email: "@" symbol is missing.');
                    }
                  }}
                  required
                />
                <HeadingAndData
                  label="Address"
                  name="address"
                  placeholder="Enter staff address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>

              <div className={styles.actionsRow}>
                <SaveAndCancel
                  onSave={() => console.log('Saved Staff')}
                  onCancel={() => {
                    setStaffFirstName('');
                    setStaffLastName('');
                    setEmail('');
                    setMobile('');
                    setAddress('');
                    setEmail('');
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Professional Details */}
        <div className={styles.sectionBox}>
          <div className={styles.sectionContainer}>
            <div className={styles.sectionHeaderBox}>
              <HeadingAndIcon
                icon={<FaUser />}
                heading="Professional Details"
              />
            </div>

            <div className={styles.inputCard}>
              <div className={styles.inputsRow}>
                <HeadingAndDropDown
                  label="Role"
                  name="role"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  required
                  options={[
                    { label: 'Teacher', value: 'teacher' },
                    { label: 'Admin', value: 'admin' },
                  ]}
                  placeholder="Choose role"
                />
                <HeadingAndDropDown
                  label="Room"
                  name="room"
                  value={room}
                  onChange={(e) => setRoom(e.target.value)}
                  options={[
                    { label: 'Room 101', value: 'room101' },
                    { label: 'Room 102', value: 'room102' },
                  ]}
                  placeholder="Choose room"
                />
                <HeadingAndDropDown
                  label="Program"
                  name="program"
                  value={program}
                  onChange={(e) => setProgram(e.target.value)}
                  options={[
                    { label: 'Program A', value: 'programA' },
                    { label: 'Program B', value: 'programB' },
                  ]}
                  placeholder="Choose program"
                />
              </div>

              <div className={styles.inputsRow}>
                <HeadingAndDropDown
                  label="Group"
                  name="group"
                  value={group}
                  onChange={(e) => setGroup(e.target.value)}
                  required
                  options={[
                    { label: 'Group A', value: 'groupA' },
                    { label: 'Group B', value: 'groupB' },
                  ]}
                  placeholder="Choose group"
                />
                <HeadingAndData
                  label="Join Date"
                  name="joinDate"
                  placeholder="Select joining date"
                  type="date"
                  value={joinDate}
                  onChange={(e) => setJoinDate(e.target.value)}
                  required
                />
              </div>

              <div className={styles.actionsRow}>
                <SaveAndCancel
                  onSave={() => console.log('Saved Professional')}
                  onCancel={() => {
                    setRole('');
                    setRoom('');
                    setProgram('');
                    setGroup('');
                    setJoinDate('');
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStaffModal;
